module.exports = __webpack_public_path__ + "img/5.1fc73d27.png";